module.exports = __webpack_public_path__ + "static/media/how-to-start-image-4.e0562b65.png";